import { render } from "./AddConferenceModal.vue?vue&type=template&id=7aae89fd"
import script from "./AddConferenceModal.vue?vue&type=script&lang=js"
export * from "./AddConferenceModal.vue?vue&type=script&lang=js"
script.render = render

export default script